import { createStore, applyMiddleware, compose, Middleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import rootReducer from './reducers';

const middlewares: Middleware[] = [thunk as Middleware];

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
};

const isProduction = process.env.NODE_ENV === 'production';

const getEnhancer = () => {
  const middlewareList = isProduction ? middlewares : [...middlewares, logger as Middleware];
  const middlewareEnhancer = applyMiddleware(...middlewareList);

  return isProduction
    ? compose(middlewareEnhancer)
    : composeWithDevTools({
      trace: true,
      traceLimit: 25,
      name: 'Briklo Editor Store',
    })(middlewareEnhancer);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = createStore(
  persistedReducer,
  {},
  getEnhancer()
);
const persistor = persistStore(store);

export default () => {
  return { store, persistor };
};
